import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { getCases } from '../../actions/case-actions';
import { formatDate } from '../../actions/global-actions';
import { BsSearch, BsArrowUp, BsArrowDown } from "react-icons/bs";
import DatePicker from 'react-date-picker';
import Paginator from '../../components/paginator/paginator';
import { provinces } from '../../actions/global-actions-data';
import '../../styles/cases.css';
import { adminCasesTableBody, adminCasesTableHeaders, territorialEntity } from './../legal-cases/case-data';
import TableComponent from '../../components/table/table';
import { commentsTableBody, commentsTableHeaders } from '../legal-cases/comments/comments-data';
import ExcelGenerator from '../../components/excel-generator/excel-generator';

function DocumentsReport(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [cases, setCases] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const user = useSelector(state => state.user.user);
    const [showContainer, setShowContainer] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [citiesData, setCitiesData] = useState({
        caseCities: [],
        clientCities: []
    });
    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });
    const [skip, setSkip] = useState(0);
    const [reportType, setReportType] = useState('');
    const [selectedReport, setSelectedReport] = useState('');

    const [form, setForm] = useState({
        date: '',
        endDate: '',
        year: '',
        filingNumber: '',
        client: '',
        clientID: '',
        attorney: '',
        organ: '',
        province: '',
        city: '',
        legalCompany: '',
        status: 'Todos',
        representative: '',
        position: '',
        statePosition: '',
        territorialEntity: '',
        executionProvince: '',
        executionCity: '',
    });

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log('response', data.data);

                if (data.data && data.data.length > 0) {
                    data.data.map( caseObj => {
                        let type = caseObj.caseType;
                        caseObj.caseType = type.charAt(0).toUpperCase() + type.slice(1);
                        caseObj.legalCompany = caseObj.legalCompany? caseObj.legalCompany: 'AYH';
                        if (caseObj.status === "not checked") {
                            caseObj.status = "Sin revisar"
                        }
                        if (caseObj.status === "checked") {
                            caseObj.status = "Revisado"
                        }
                        if (caseObj.status === "finished") {
                            caseObj.status = "Terminado"
                        }
                        caseObj.formattedDate = formatDate(caseObj.date, 4);
                        caseObj.attorneyText = `${caseObj.attorneyInCharge.userId.firstName} ${caseObj.attorneyInCharge.userId.lastName}`;
                        caseObj.clientText = `${caseObj.client.clientId.firstName} ${caseObj.client.clientId.lastName}`;
                        caseObj.details = `${caseObj.case.position} No.${caseObj.autoOpening}`;
                        if (selectedReport === '2') {
                            caseObj.commentsText = caseObj.comments.length || 0;
                        }
                        return caseObj;
                    });
                }
                setCases(data.data);
    
                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }

        if (loadData) {
            setLoadData(false);
            setCases([]);
            let params = form;
            if (selectedReport === '2') {
                params = {
                    ...params,
                    query: { "comments.0" : { "$exists" : true } }
                }
            }
            dispatch( getCases( params, skip, getFunction, user.token ) );
        }
    }, [loadData, dispatch, user.token, form, skip, paginatorData, selectedReport ]);

    const toggleContainer = () => {
        setShowContainer(!showContainer)
    }
    
    const handleDateChange = ( name, date ) => {
        if (!date) {
            setForm({
                ...form,
                [name] :  ''
            });
            return;
        }
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleOnChange = (event, position) => {
        const value = event.target.value;
        if (value !== '' && value) {
            const cities = provinces.find( x => x.name === value).cities;
            if (position === 'case') {
                setCitiesData({
                    ...citiesData,
                    caseCities: cities
                })
                setForm({
                    ...form,
                    [event.target.name]: event.target.value,
                    city: ''
                });
                return;
            }

            setCitiesData({
                ...citiesData,
                clientCities: cities
            })
            setForm({
                ...form,
                [event.target.name]: event.target.value,
                executionCity: ''
            });
            return;
      
        }
        if (position === 'case') {
            setCitiesData({
                ...citiesData,
                caseCities: []
            })
            setForm({
                ...form,
                city :  '',
                province: ''
            })
            return;
        }

        setCitiesData({
            ...citiesData,
            clientCities: []
        })
        setForm({
            ...form,
            executionCity :  '',
            executionProvince: ''
        })            
    }

    const handleReportOnChange = (event) => {
        const value = event.target.value;
        setReportType(value);
        defaultValues();       
    }

    const deleteSearch = () => {
        defaultValues();
    }

    const defaultValues = () => {
        setForm({
            date: '',
            endDate: '',
            year: '',
            filingNumber: '',
            client: '',
            clientID: '',
            attorney: '',
            organ: '',
            province: '',
            city: '',
            legalCompany: '',
            status: 'Todos',
            representative: '',
            position: '',
            statePosition: '',
            territorialEntity: '',
            executionProvince: '',
            executionCity: '',
        })
        setCitiesData({
            caseCities: [],
            clientCities: []
        })
        stockPaginator();
        setIsSearched(false);
        setSelectedReport("")
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    const handleReportSubmit = () => {
        const isEmpty = reportType === null || reportType === ''?true:false;
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe seleccionar un tipo de reporte para continuar",
            });
            return;
        } else {
            setSelectedReport(reportType);
            stockPaginator();
            setIsSearched(true);
            setLoadData(true);
        }
    }

    const searchFunction = () => {
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar algún campo para continuar",
            });
            return;
        } else {
            setSelectedReport(reportType);
            stockPaginator();
            setIsSearched(true);
            setLoadData(true);
        }
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] !== '' && form[field] ) {
                    return false
                }
            }
        }
        return true
    }

    useEffect(() => {
        //console.log(form)
        //console.log(reportType)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Descargar casos jurídicos</h1>
                <div className="w-100 d-flex flex-wrap">
                    <h5 className='filter-text w-100'>Seleccione un tipo de reporte</h5>
                    <div className="d-flex flex-column w-25 field">
                        <label className="label-field" htmlFor="reportType">Tipo</label>
                        <select className="input-field" id="reportType" name="reportType" onChange={(e)=>handleReportOnChange(e)} value={reportType}>
                            <option value=""></option>
                            <option value="1">Descargar casos</option>
                            <option value="2">Descargar comentarios</option>
                        </select>
                    </div>
                </div>
                {(reportType!==null && reportType!=='') &&
                    <div className="d-flex flex-column w-100">
                        <div onClick={toggleContainer} style={{ width: 'fit-content', cursor: 'pointer'}}>
                            <h4 className="w-100 my-2 d-flex"> Filtros
                                {showContainer?
                                    <BsArrowUp className="arrow-icon"/>
                                :
                                    <BsArrowDown className="arrow-icon"/>
                                }
                            </h4>
                        </div>
                        {showContainer &&
                            <div className="w-100 d-flex flex-wrap">
                                <h5 className='filter-text w-100'>Datos del caso</h5>
                                <span className='w-100 m-2'><i>Para buscar un caso de una fecha específica solo ponga la fecha de inicio</i></span>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field">Fecha inicio</label>
                                    <DatePicker
                                        value={ form.date }
                                        dayAriaLabel={"Día"}
                                        dayPlaceholder={"dd"}
                                        monthAriaLabel={"Mes"}
                                        monthPlaceholder={"mm"}
                                        yearAriaLabel={"Año"}
                                        yearPlaceholder={"yyyy"}
                                        name={"date"}
                                        onChange={ (date)=>handleDateChange( 'date', date ) }
                                        dateFormat="MM/dd/yyyy"
                                    />
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field">Fecha fin</label>
                                    <DatePicker
                                        value={ form.endDate }
                                        dayAriaLabel={"Día"}
                                        dayPlaceholder={"dd"}
                                        monthAriaLabel={"Mes"}
                                        monthPlaceholder={"mm"}
                                        yearAriaLabel={"Año"}
                                        yearPlaceholder={"yyyy"}
                                        name={"date"}
                                        onChange={ (date)=>handleDateChange( 'endDate', date ) }
                                        dateFormat="MM/dd/yyyy"
                                    />
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="filingNumber">Radicado</label>
                                    <input type="text" className="input-field" id="filingNumber" name="filingNumber" autoComplete="off" placeholder="No de radicado" onChange={handleInputChange} value={form.filingNumber}></input>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="attorney">Abogado</label>
                                    <input type="text" className="input-field" id="attorney" name="attorney" autoComplete="off" placeholder="Nombre, apellido o documento" onChange={handleInputChange} value={form.attorney}></input>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="organ">Órgano de investigación</label>
                                    <input type="text" className="input-field" id="organ" name="organ" autoComplete="off" placeholder="Buscar órgano por su nombre" onChange={handleInputChange} value={form.organ}></input>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="province">Departamento</label>
                                    <select className="input-field" id="province" name="province" onChange={(e) =>handleOnChange(e, 'case')} value={form.province}>
                                        <option></option>
                                        {provinces.map((province) => (
                                            <option key={province.name} value={province.name}>{province.name}</option>
                                        ))}
                                    </select>
                                </div>
                                {form.province !== '' && citiesData.caseCities && citiesData.caseCities !== [] && 
                                    <div className="d-flex flex-column w-25 field">
                                        <label className="label-field" htmlFor="city">Ciudad del caso</label>
                                        <select className="input-field" id="city" name="city" onChange={handleInputChange} value={form.city}>
                                            <option></option>
                                            {citiesData.caseCities.map((city) => (
                                                <option key={city.name} value={city.name}>{city.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                }
                                <div  className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="legalCompany">Empresa</label>
                                    <select className="input-field" id="legalCompany" name="legalCompany" onChange={handleInputChange} value={form.legalCompany}>
                                        <option value=""></option>
                                        <option value="AYH">AYH</option>
                                        <option value="VAF">VAF</option>
                                    </select>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="representative">Personero &#47; Funcionario</label>
                                    <input type="text" className="input-field" id="representative" name="representative" autoComplete="off" placeholder="" onChange={handleInputChange} value={form.representative}></input>
                                </div>
                                <div  className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="status">Estado del caso</label>
                                    <select className="input-field" id="status" name="status" onChange={handleInputChange} value={form.status}>
                                        <option value="Todos">Todos</option>
                                        <option value="Abierto">Abierto</option>
                                        <option value="Cerrado">Cerrado</option>
                                    </select>
                                </div>
                                <h5 className='filter-text w-100'>Datos del cliente</h5>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="client">Cliente</label>
                                    <input type="text" className="input-field" id="client" name="client" autoComplete="off" placeholder="Nombre, apellido o documento" onChange={handleInputChange} value={form.client}></input>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="position">Cargo</label>
                                    <input type="text" className="input-field" id="position" name="position" autoComplete="off" onChange={handleInputChange} value={form.position}></input>
                                </div>
                                <div  className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="statePosition">Estado del cargo</label>
                                    <select className="input-field" id="statePosition" name="statePosition" onChange={handleInputChange} value={form.statePosition}>
                                        <option value=""></option>
                                        <option value="actual">Actualmente</option>
                                        <option value="ex">Ex</option>
                                    </select>
                                </div>
                                <div  className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="territorialEntity">Entidad territorial</label>
                                    <select className="input-field" id="territorialEntity" name="territorialEntity" onChange={handleInputChange} value={form.territorialEntity}>
                                        <option value=""></option>
                                        {territorialEntity.map((value) => (
                                            <option key={'territorialEntity' + value} value={value}>{value}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="executionProvince">Departamento de ejecución</label>
                                    <select className="input-field" id="executionProvince" name="executionProvince" onChange={(e) =>handleOnChange(e, 'client')} value={form.executionProvince}>
                                        <option></option>
                                        {provinces.map((province) => (
                                            <option key={province.name} value={province.name}>{province.name}</option>
                                        ))}
                                    </select>
                                </div>
                                {form.executionProvince !== '' && citiesData.clientCities && citiesData.clientCities !== [] && 
                                    <div className="d-flex flex-column w-25 field">
                                        <label className="label-field" htmlFor="executionCity">Ciudad de ejecución</label>
                                        <select className="input-field" id="executionCity" name="executionCity" onChange={handleInputChange} value={form.executionCity}>
                                            <option></option>
                                            {citiesData.clientCities.map((city) => (
                                                <option key={'executionCity' + city.name} value={city.name}>{city.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                }
                                <div className="w-100 d-flex justify-content-center m-2">
                                    <div className="d-flex search-button with-text justify-content-center align-items-center" onClick={searchFunction}>
                                        Filtrar
                                    </div>
                                </div>
                                <div className="w-100 d-flex justify-content-center my-1">
                                    <span className="delete-search-text" onClick={deleteSearch}>
                                        Eliminar filtros
                                    </span>
                                </div>
                            </div>
                        }
                    </div>
                }
                {!isSearched &&
                    <div className="w-100 d-flex justify-content-center m-2">
                        <div className="d-flex search-button with-text justify-content-center align-items-center" onClick={handleReportSubmit}>
                            <span>Buscar</span>
                            <BsSearch/>
                        </div>
                    </div>
                }
                {(isSearched) &&
                    <div className="d-flex flex-column">
                        <div className="w-100 d-flex justify-content-between mt-3 mb-1">
                            <span className='align-self-center'>Casos: <b>{paginatorData.totalitems}</b></span>
                        </div>
                        {selectedReport === '1' &&
                            <TableComponent
                                id={"cases-table"}
                                headers={adminCasesTableHeaders}
                                body={adminCasesTableBody}
                                skip={skip}
                                data={cases}
                                link={`${currentLink}/editar/`}
                                needOptions={true}
                                />
                        }
                        {selectedReport === '2' &&
                            <TableComponent
                                id={"comments-table"}
                                headers={commentsTableHeaders}
                                body={commentsTableBody}
                                skip={skip}
                                data={cases}
                                link={`${currentLink}/historial/`}
                                />
                        }
                        {paginatorData.totalpages > 0 && paginatorData.currentpage > 0 &&
                            <Paginator 
                                data={paginatorData}
                                skip={skip}
                                setSkip={(n) => setSkip(n)}
                                setLoadData={(need) => setLoadData(need)}
                            />
                        }
                        {cases.length>0 &&
                            <div className="w-100 d-flex justify-content-center m-2">
                                <ExcelGenerator
                                    token={user.token}
                                    form={form}
                                    selectedReport={selectedReport}
                                    />
                            </div>
                        }
                    </div>
                }                
            </div>
        </div>
    );
}

export default DocumentsReport;
  